import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styling/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const contactLinks = [
    {
      label: 'Email',
      href: 'mailto:robinokwanma@gmail.com',
      icon: 'envelope'
    },
    {
      label: 'Phone',
      href: 'tel:+2348148190856',
      icon: 'telephone'
    },
    {
      label: 'Website',
      href: 'https://www.justrobin.dev',
      icon: 'globe',
      target: '_blank'
    },
    {
      label: 'Upwork',
      href: 'https://www.upwork.com/freelancers/robinokwanma',
      icon: 'briefcase',
      target: '_blank'
    }
  ];

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-content">
          {/* About Section */}
          <Col lg={4} md={6} sm={12} className="footer-section">
            <div className="footer-title">About</div>
            <p className="footer-text">
              Full-stack engineer specializing in fintech and mobile applications. Building production-ready systems with React Native & Django.
            </p>
          </Col>

          {/* Quick Links */}
          <Col lg={4} md={6} sm={12} className="footer-section">
            <div className="footer-title">Connect</div>
            <div className="footer-links">
              {contactLinks.map((link, idx) => (
                <a
                  key={idx}
                  href={link.href}
                  target={link.target || '_self'}
                  rel="noopener noreferrer"
                  className="footer-link"
                  title={link.label}
                >
                  <i className={`bi bi-${link.icon} link-icon`}></i>
                  <span className="link-text">{link.label}</span>
                </a>
              ))}
            </div>
          </Col>

          {/* Status Section */}
          <Col lg={4} md={12} sm={12} className="footer-section">
            <div className="footer-title">Status</div>
            <div className="status-badge">
              <span className="status-dot"></span>
              <span className="status-text">Available for Projects</span>
            </div>
            <div className="upwork-badge">
              <i className="bi bi-star-fill badge-icon"></i>
              <div>
                <div className="badge-title">Top Rated Plus</div>
                <div className="badge-subtitle">20+ Projects Completed</div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Footer Bottom */}
        <Row className="footer-bottom">
          <Col md={6} sm={12} className="footer-copyright">
            <i className="bi bi-heart-fill copyright-icon"></i>
            <span>Designed & Built by Robin Okwanma</span>
          </Col>
          <Col md={6} sm={12} className="footer-meta">
            <span className="meta-text">© {currentYear} All rights reserved</span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;